import { fetchWrapper, withApiBaseUrl } from './fetch';

export const putLet2OwnRenewal = async (accountId: number) =>
  await fetchWrapper(withApiBaseUrl(`/letting/let2own/renewal/${accountId}`), {
    method: 'PUT',
    credentials: 'include',
  });
